import { isPath } from '@/utils/promoterAccess';

export function sessionMenu(payload) {
  const { menu, default_route: landing } = payload ?? {};

  if (!Array.isArray(menu) || !isPath(landing)) return null;

  return { default: landing, routers: menu };
}

export function storeSessionMenu(payload) {
  const menu = sessionMenu(payload);

  if (!menu) return false;

  try {
    localStorage.setItem('menu', JSON.stringify(menu));

    return true;
  } catch {
    return false;
  }
}

export function dropSessionMenu() {
  try {
    localStorage.removeItem('menu');

    return true;
  } catch {
    return false;
  }
}
